import { MutationTree } from 'vuex'
import { BootcampsState } from './state'
import { Bootcamp } from '../../types'

const mutations: MutationTree<BootcampsState> = {
  CURRENT_BOOTCAMPS: (
    state,
    bootcamps: {
      current?: Array<Bootcamp>
      next?: Bootcamp
      upcoming: Array<Bootcamp>
      past?: Array<Bootcamp>
    }
  ) => {
    state.currentBootcamps = bootcamps
  },
  SELECTED_BOOTCAMP_UPDATED: (state, bootcamp: Bootcamp) => {
    state.selectedBootcamp = bootcamp
  },
}

export default mutations
